import Cookies from 'js-cookie';
import { get } from 'lodash';

import { GEOFENCING_SHOPS } from 'constants/geofencing';
import ACTIONS, { GEOFENCING_COOKIES } from 'state/constants';
import Settings from 'utils/Settings';
import { getCurrentDomain, navigateToUrl } from 'utils/Url';

const setUserSelectedShopAndRedirect = store => next => action => {
  next(action);

  if (action.type === ACTIONS.SET_GEOFENCING_SHOP_SELECTION) {
    const state = store.getState();
    const userSelectedShopID = get(state, ['geofencing', 'userSelectedShopID']);
    const domain = getCurrentDomain();

    Cookies.set(GEOFENCING_COOKIES.USER_SELECTED_SHOP, userSelectedShopID, {
      domain,
    });

    if (userSelectedShopID !== Settings.shopID) {
      const selectedShopUrl = get(GEOFENCING_SHOPS, [userSelectedShopID, 'url']);
      const currentQueryParams = window.location.search || '';
      const url = `${selectedShopUrl}${currentQueryParams}`;

      navigateToUrl(url);
    }
  }
};

export default setUserSelectedShopAndRedirect;
